import { useTheme } from '@mui/material/styles';
// import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Divider } from '@eatclubcode/ec-component-library';
import { countries, regions } from '../../utils/valueLists';
import ColumnSection from '../ColumnSection/ColumnSection';
import CleanDropdown from '../Dropdown/CleanDropdown';
import CleanTextField from '../TextField/CleanTextField';
import useStyles, { dropdownStyles, textFieldStyles } from './ProfileStyles';
import FacebookIconSVG from '../../assets/icon_facebook.svg';
import TwitterIconSVG from '../../assets/icon_twitter.svg';
import InstaIconSVG from '../../assets/icon_insta.svg';
import { restaurantActivePropTypes } from '../../data/models/Restaurant';
// import { saveRestaurantAction } from '../../data/actions/restaurantAction';

const Profile = ({ restaurantActive }) => {
  const theme = useTheme();
  const classes = useStyles();

  const textFieldStyle = textFieldStyles(theme);
  const dropdownStyle = dropdownStyles(theme);

  const [name, setName] = useState(restaurantActive.restaurant.name || '');
  const [slug, setSlug] = useState(restaurantActive.restaurant.slug || '');
  const [address, setAddress] = useState(restaurantActive.restaurant.address1 || '');
  const [city, setCity] = useState(restaurantActive.restaurant.region || '');
  const [state, setState] = useState(restaurantActive.restaurant.state || '');
  const [postcode, setPostcode] = useState(restaurantActive.restaurant.postcode || '');
  const [country, setCountry] = useState('Australia');
  const [phone, setPhone] = useState(restaurantActive.restaurant.phone || '');
  const [website, setWebsite] = useState(restaurantActive.restaurant.website || '');
  const [abn, setAbn] = useState(restaurantActive.restaurant.abn || '');
  const [tradingName, setTradingName] = useState(restaurantActive.restaurant.tradingName || '');
  const [instagram, setInstagram] = useState(restaurantActive.restaurant.instagramLink || '');
  const [facebook, setFacebook] = useState(restaurantActive.restaurant.facebookLink || '');
  const [twitter, setTwitter] = useState(restaurantActive.restaurant.twitterLink || '');

  useEffect(() => {
    setName(restaurantActive.restaurant.name || '');
    setSlug(restaurantActive.restaurant.slug || '');
    setAddress(restaurantActive.restaurant.address1 || '');
    setCity(restaurantActive.restaurant.region || '');
    setState(restaurantActive.restaurant.state || '');
    setPostcode(restaurantActive.restaurant.postcode || '');
    setCountry('Australia');
    setPhone(restaurantActive.restaurant.phone || '');
    setWebsite(restaurantActive.restaurant.website || '');
    setAbn(restaurantActive.restaurant.abn || '');
    setTradingName(restaurantActive.restaurant.tradingName || '');
    setInstagram(restaurantActive.restaurant.instagramLink || '');
    setFacebook(restaurantActive.restaurant.facebookLink || '');
    setTwitter(restaurantActive.restaurant.twitterLink || '');
  }, [restaurantActive.restaurant]);

  /**
   * Update the profile settings
   * Happens on blur when editing
   */
  // const updateProfile = (fieldToUpdate, newValue) => {
  const updateProfile = () => {
    // uncomment when apis are done
    // if (isEmpty(restaurantActive.restaurant[fieldToUpdate]) && isEmpty(newValue)) {
    //   return;
    // }
    // if (restaurantActive.restaurant[fieldToUpdate] !== newValue) {
    //   saveRestaurant({ ...restaurantActive.restaurant, [fieldToUpdate]: newValue });
    // }
  };

  return (
    <Box className={classes.container}>
      <ColumnSection label='Account Details'>
        <Box className={classes.twoColumn}>
          <Box className={classes.settings}>
            <CleanTextField
              label='Venue name'
              value={name}
              onChange={setName}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('name', e.target.value)}
              disabled
            />
            <CleanTextField
              label='Account name'
              value={slug}
              onChange={setSlug}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('slug', e.target.value)}
              disabled
            />
            <CleanTextField
              label='Address'
              value={address}
              onChange={setAddress}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('address1', e.target.value)}
              disabled
            />
            <CleanTextField
              label='City'
              value={city}
              onChange={setCity}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('region', e.target.value)}
              disabled
            />
            <CleanDropdown
              label='State / Territory'
              items={regions()}
              value={state}
              onSelect={(value) => {
                setState(value);

                updateProfile('state', value);
              }}
              style={dropdownStyle}
              disabled
            />
            <CleanTextField
              label='Postcode'
              value={postcode}
              onChange={setPostcode}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('postcode', e.target.value)}
              disabled
            />
            <CleanDropdown
              label='Country'
              items={countries()}
              value={country}
              style={dropdownStyle}
              disabled
              onBlur={(e) => updateProfile('country', e.target.value)}
            />
            <CleanTextField
              label='Phone'
              value={phone}
              onChange={setPhone}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('phone', e.target.value)}
              disabled
            />
            <CleanTextField
              label='Website'
              value={website}
              onChange={setWebsite}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('website', e.target.value)}
              disabled
            />
            <CleanTextField
              label='ABN'
              value={abn}
              onChange={setAbn}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('abn', e.target.value)}
              disabled
            />
            <CleanTextField
              label='Company or Trading Name'
              value={tradingName}
              onSelect={setTradingName}
              style={textFieldStyle}
              onBlur={(e) => updateProfile('tradingName', e.target.value)}
              disabled
            />
          </Box>
        </Box>
      </ColumnSection>
      <Divider />
      <ColumnSection label='Socials'>
        <Box className={classes.settings}>
          <CleanTextField
            label={
              <Box className={classes.iconLabel}>
                <InstaIconSVG style={{ width: '20px' }} />
                <Box>Instagram</Box>
              </Box>
            }
            value={instagram}
            onChange={setInstagram}
            style={textFieldStyle}
            onBlur={(e) => updateProfile('instagramLink', e.target.value)}
            disabled
          />
          <CleanTextField
            label={
              <Box className={classes.iconLabel}>
                <FacebookIconSVG style={{ width: '20px' }} />
                <Box>Facebook</Box>
              </Box>
            }
            value={facebook}
            onChange={setFacebook}
            style={textFieldStyle}
            onBlur={(e) => updateProfile('facebookLink', e.target.value)}
            disabled
          />
          <CleanTextField
            label={
              <Box className={classes.iconLabel}>
                <TwitterIconSVG style={{ width: '20px' }} />
                <Box>Twitter</Box>
              </Box>
            }
            value={twitter}
            onChange={setTwitter}
            style={textFieldStyle}
            onBlur={(e) => updateProfile('twitterLink', e.target.value)}
            disabled
          />
        </Box>
      </ColumnSection>
    </Box>
  );
};

Profile.propTypes = {
  restaurantActive: restaurantActivePropTypes.isRequired,
  // saveRestaurant: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  restaurantActive: state.restaurantActive,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // saveRestaurant: saveRestaurantAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
